import Integration from './Integration.page';

export default Integration;
